import {ModelSection, DocumentSection} from '@/engine';
import {computeGroup} from './document-group';
import {DocumentProcessorUtils} from './utils';

export const computeSection =
  (utils: DocumentProcessorUtils) =>
  ({title, displayIf, validations, onSubmit, onMount, groups, ...section}: ModelSection): DocumentSection => {
    const {computeConditions, computeValidations, computeEvents, valueResolver, visibilitySet} = utils;

    const visible = computeConditions(displayIf);
    if (visible) {
      visibilitySet.add(section.id);
    } else {
      visibilitySet.delete(section.id);
    }

    return {
      ...section,
      title: title(valueResolver, visibilitySet),
      visible,
      validations: computeValidations(validations(valueResolver, visibilitySet)),
      onSubmit: computeEvents(onSubmit),
      onMount: computeEvents(onMount),
      groups: groups.map(computeGroup(utils, section.id)),
    };
  };
